module.exports = __webpack_public_path__ + "static/img/Logotipo_Positivo_Vertical.fc58f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paginaoficial/Logotipo_Positivo_Vertical.png
// module id = 6Ca8
// module chunks = 2